'use client';
import { isDev } from 'app/general';
import mixpanel from 'mixpanel-browser'

mixpanel.init(process.env.MIXPANEL_ID as string, { debug: true, track_pageview: true, persistence: 'localStorage' });

const mixpanelActions = {

    track: (name: string, props?: any) => {
        if (isDev) {
            return
        }
        try {
            mixpanel?.track(name, props)
        } catch (e) {
            console.error(e)
        }
    },
    identify: (id: string) => {
        if (isDev) {
            return
        }
        try {
            mixpanel?.identify(id)
        } catch (e) {
            console.error(e)
        }
    },

}

export { mixpanelActions }